// source: pbtypes/gen/scan_planner/contour_scan_request.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_eigen_lcm_Quaternionf_pb = require('../../../pbtypes/gen/eigen_lcm/Quaternionf_pb.js');
goog.object.extend(proto, pbtypes_gen_eigen_lcm_Quaternionf_pb);
var pbtypes_gen_scan_planner_slice_dim_pb = require('../../../pbtypes/gen/scan_planner/slice_dim_pb.js');
goog.object.extend(proto, pbtypes_gen_scan_planner_slice_dim_pb);
goog.exportSymbol('proto.scan_planner.ContourScanRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scan_planner.ContourScanRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scan_planner.ContourScanRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scan_planner.ContourScanRequest.displayName = 'proto.scan_planner.ContourScanRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scan_planner.ContourScanRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.scan_planner.ContourScanRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scan_planner.ContourScanRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.ContourScanRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
sliceDim: jspb.Message.getFieldWithDefault(msg, 1, 0),
desiredRange: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
sliceOverlapFraction: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
waypointOverlapFraction: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
zLookdownAngle: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
avoidRedundantCoverage: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
adjustUnreachablePhotos: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
useArbitraryAxis: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
axisRGlobalMap: (f = msg.getAxisRGlobalMap()) && pbtypes_gen_eigen_lcm_Quaternionf_pb.QuaternionfPb.toObject(includeInstance, f),
smallGapsDistance: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
thresholdForOccupied: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scan_planner.ContourScanRequest}
 */
proto.scan_planner.ContourScanRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scan_planner.ContourScanRequest;
  return proto.scan_planner.ContourScanRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scan_planner.ContourScanRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scan_planner.ContourScanRequest}
 */
proto.scan_planner.ContourScanRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.scan_planner.SliceDim.Enum} */ (reader.readEnum());
      msg.setSliceDim(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setDesiredRange(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setSliceOverlapFraction(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setWaypointOverlapFraction(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setZLookdownAngle(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAvoidRedundantCoverage(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAdjustUnreachablePhotos(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseArbitraryAxis(value);
      break;
    case 9:
      var value = new pbtypes_gen_eigen_lcm_Quaternionf_pb.QuaternionfPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Quaternionf_pb.QuaternionfPb.deserializeBinaryFromReader);
      msg.setAxisRGlobalMap(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setSmallGapsDistance(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setThresholdForOccupied(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scan_planner.ContourScanRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scan_planner.ContourScanRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scan_planner.ContourScanRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.ContourScanRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSliceDim();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getDesiredRange();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getSliceOverlapFraction();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getWaypointOverlapFraction();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = message.getZLookdownAngle();
  if (f !== 0.0) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = message.getAvoidRedundantCoverage();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getAdjustUnreachablePhotos();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getUseArbitraryAxis();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getAxisRGlobalMap();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      pbtypes_gen_eigen_lcm_Quaternionf_pb.QuaternionfPb.serializeBinaryToWriter
    );
  }
  f = message.getSmallGapsDistance();
  if (f !== 0.0) {
    writer.writeFloat(
      10,
      f
    );
  }
  f = message.getThresholdForOccupied();
  if (f !== 0.0) {
    writer.writeFloat(
      11,
      f
    );
  }
};


/**
 * optional SliceDim.Enum slice_dim = 1;
 * @return {!proto.scan_planner.SliceDim.Enum}
 */
proto.scan_planner.ContourScanRequest.prototype.getSliceDim = function() {
  return /** @type {!proto.scan_planner.SliceDim.Enum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.scan_planner.SliceDim.Enum} value
 * @return {!proto.scan_planner.ContourScanRequest} returns this
 */
proto.scan_planner.ContourScanRequest.prototype.setSliceDim = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional float desired_range = 2;
 * @return {number}
 */
proto.scan_planner.ContourScanRequest.prototype.getDesiredRange = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.ContourScanRequest} returns this
 */
proto.scan_planner.ContourScanRequest.prototype.setDesiredRange = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional float slice_overlap_fraction = 3;
 * @return {number}
 */
proto.scan_planner.ContourScanRequest.prototype.getSliceOverlapFraction = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.ContourScanRequest} returns this
 */
proto.scan_planner.ContourScanRequest.prototype.setSliceOverlapFraction = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional float waypoint_overlap_fraction = 4;
 * @return {number}
 */
proto.scan_planner.ContourScanRequest.prototype.getWaypointOverlapFraction = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.ContourScanRequest} returns this
 */
proto.scan_planner.ContourScanRequest.prototype.setWaypointOverlapFraction = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional float z_lookdown_angle = 5;
 * @return {number}
 */
proto.scan_planner.ContourScanRequest.prototype.getZLookdownAngle = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.ContourScanRequest} returns this
 */
proto.scan_planner.ContourScanRequest.prototype.setZLookdownAngle = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional bool avoid_redundant_coverage = 6;
 * @return {boolean}
 */
proto.scan_planner.ContourScanRequest.prototype.getAvoidRedundantCoverage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scan_planner.ContourScanRequest} returns this
 */
proto.scan_planner.ContourScanRequest.prototype.setAvoidRedundantCoverage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool adjust_unreachable_photos = 7;
 * @return {boolean}
 */
proto.scan_planner.ContourScanRequest.prototype.getAdjustUnreachablePhotos = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scan_planner.ContourScanRequest} returns this
 */
proto.scan_planner.ContourScanRequest.prototype.setAdjustUnreachablePhotos = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool use_arbitrary_axis = 8;
 * @return {boolean}
 */
proto.scan_planner.ContourScanRequest.prototype.getUseArbitraryAxis = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scan_planner.ContourScanRequest} returns this
 */
proto.scan_planner.ContourScanRequest.prototype.setUseArbitraryAxis = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional eigen_lcm.QuaternionfPb axis_r_global_map = 9;
 * @return {?proto.eigen_lcm.QuaternionfPb}
 */
proto.scan_planner.ContourScanRequest.prototype.getAxisRGlobalMap = function() {
  return /** @type{?proto.eigen_lcm.QuaternionfPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_eigen_lcm_Quaternionf_pb.QuaternionfPb, 9));
};


/**
 * @param {?proto.eigen_lcm.QuaternionfPb|undefined} value
 * @return {!proto.scan_planner.ContourScanRequest} returns this
*/
proto.scan_planner.ContourScanRequest.prototype.setAxisRGlobalMap = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scan_planner.ContourScanRequest} returns this
 */
proto.scan_planner.ContourScanRequest.prototype.clearAxisRGlobalMap = function() {
  return this.setAxisRGlobalMap(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scan_planner.ContourScanRequest.prototype.hasAxisRGlobalMap = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional float small_gaps_distance = 10;
 * @return {number}
 */
proto.scan_planner.ContourScanRequest.prototype.getSmallGapsDistance = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.ContourScanRequest} returns this
 */
proto.scan_planner.ContourScanRequest.prototype.setSmallGapsDistance = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional float threshold_for_occupied = 11;
 * @return {number}
 */
proto.scan_planner.ContourScanRequest.prototype.getThresholdForOccupied = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.ContourScanRequest} returns this
 */
proto.scan_planner.ContourScanRequest.prototype.setThresholdForOccupied = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


goog.object.extend(exports, proto.scan_planner);
